import { IMatchRunPosition } from '@nkr/models/index';

export interface IConfirmRexm extends IMatchRunPosition {
    swapIndex: number,
    chainIndex: number,
    pathIndex: number,
}